import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { eventsStore } from './redux';

import CalendarContainer from './components/calendar-container';
import { CalendarAppState } from './classes/redux-states';

render(
    <Provider store={eventsStore}>
        <CalendarContainer />
    </Provider>

    , document.getElementById("calendar-entry-js"));




// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/index.tsx